// extracted by mini-css-extract-plugin
export default {"navLinks":"NavLinks_navLinks__9pJ+O","iconWrapper":"NavLinks_iconWrapper__6b2eO","active":"NavLinks_active__o14PV","textWrapper":"NavLinks_textWrapper__yOtWi"};